<template>
  <div class="quick-date mt-2">
    <el-form ref="dateSelection" class="clearfix">
      <!-- 快捷日期 -->
      <el-form-item class="form-float-right fast">
        <div class="form-float-right customize-btn">
          <div :class="{dateLimit:hasConfirmDate}" @click="handleDrawerDate">{{ selDateLimit }}</div>
        </div>
      </el-form-item>
      <el-form-item v-if="isShowQuickTime" class="form-float-right">
        <el-radio-group v-for="item of fastDateOptions" :key="item.label" v-model="curFastDate">
          <el-radio style="padding-right:13px" :label="item.label" @click.native.prevent="fastChange(item)" />
        </el-radio-group>
      </el-form-item>
    </el-form>
    <Drawer
      custom-class="quick-data-drawer"
      :title="dialogTitle"
      :visible.sync="isShowDrawerDialog"
      :is-use-append="isUseAppend"
      @confirm="handleConfirmDialog"
    >
      <el-form ref="customizeForm" class="customize-form" :model="customizeForm">
        <el-form-item :label="$t('时间类型：')" required>
          <el-radio-group v-model="customizeForm.dateType" @change="typeChange">
            <el-radio label="0">{{ $t('自然日') }}</el-radio>
            <el-radio label="1">{{ $t('自然月') }}</el-radio>
            <el-radio label="2">{{ $t('自然年') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 开始时间 -->
        <el-form-item :label="$t('时间区间：')" required>
          <el-date-picker
            v-if="rangeType === '0'"
            v-model="customizeForm.dayLimit"
            type="daterange"
            align="center"
            :start-placeholder="$t('开始日期')"
            :range-separator="$t('至')"
            :end-placeholder="$t('结束日期')"
            value-format="yyyy-MM-dd"
            :editable="false"
            :clearable="false"
            :picker-options="pickerDayOptions"
            @change="selDayLimit"
          />
          <el-date-picker
            v-if="rangeType === '1'"
            v-model="customizeForm.monthLimit"
            type="monthrange"
            align="center"
            :start-placeholder="$t('开始月份')"
            :range-separator="$t('至')"
            :end-placeholder="$t('结束月份')"
            value-format="yyyy-MM"
            :editable="false"
            :clearable="false"
            :picker-options="pickerMonthOptions"
            @change="selMonthLimit"
          />
          <div v-if="rangeType === '2'">
            <el-date-picker
              v-model="customizeForm.curStartYear"
              type="year"
              align="center"
              :placeholder="$t('开始年份')"
              value-format="yyyy"
              :editable="false"
              :clearable="false"
              :picker-options="startPickerOptions"
              @change="handleChangeStart"
            />
            <el-date-picker
              v-model="customizeForm.curEndYear"
              type="year"
              align="center"
              :placeholder="$t('结束年份')"
              value-format="yyyy"
              :editable="false"
              :clearable="false"
              :picker-options="endPickerOptions"
              @change="handleChangeEnd"
            />
          </div>
        </el-form-item>
      </el-form>
    </Drawer>
  </div>
</template>

<script>
/**
 * 组件：
 * <ceilingTag
 *  :menu-array="menuArray"
 *  :menu-ceiling="isCeiling"
 *  :is-show-time="true"
 *  :has-year="false"
 *  @handleDateChange
 *  @handleSelectIndex
 *  @handleSelectLimit />
 *
 *  menu-array 左侧菜单
 *  menu-ceiling 滑动是吸顶样式切换
 *  is-show-time 是否显示时间选择
 *  has-year 是否显示年份选择
 *
*  menuArray: [{
      {id: '1', name: this.$t('整厂能耗') },
      { id: '2', name: this.$t('区域能耗') },
      { id: '3', name: this.$t('设备能耗') }
    ]
 */
import Drawer from '@/components/klinx/common/drawer';
import i18n from '@/lang';

export default {
  name: 'QuickDateSelection',
  components: {
    Drawer
  },
  props: {
    isShowQuickTime: {
      type: Boolean,
      default: true
    },
    isUseAppend: {
      type: Boolean,
      default: false
    },
    fastDate: {
      type: String,
      default: i18n.t('近7天')
    },
    initDateLimit: {
      type: Array,
      default() {
        return [this.dayjs().subtract(7, 'days').format('YYYY-MM-DD'), this.dayjs().format('YYYY-MM-DD')];
      }
    }
  },
  data() {
    return {
      isShowDrawerDialog: false,
      dialogTitle: this.dayjs().subtract(7, 'days').format('YYYY-MM-DD') + ' ~ ' + this.dayjs().format('YYYY-MM-DD'),
      customizeForm: {
        dateType: '0',
        dayLimit: [this.dayjs().subtract(1, 'months').format('YYYY-MM-DD'), this.dayjs().subtract(1, 'days').format(
          'YYYY-MM-DD')],
        monthLimit: [this.dayjs().subtract(13, 'months').format('YYYY-MM'), this.dayjs().subtract(1, 'months').format(
          'YYYY-MM')],
        curStartYear: this.dayjs().subtract(2, 'years').format('YYYY'),
        curEndYear: this.dayjs().format('YYYY')
      },
      rangeType: '0',
      startPickerOptions: {
        disabledDate: (time) => {
          return (
          // 限制不能选择结束年份之后：小于结束年份
            time.getTime() > Date.now() - this.dayjs((new Date()).getFullYear() + '').diff(this.dayjs(this.customizeForm
              .curEndYear)) ||
              // 限制不能选择未来和12年前：大于12年前小于上一年
              time.getTime() > Date.now() ||
              time.getTime() < Date.now() - this.dayjs((new Date()).getFullYear() + '').diff(this.dayjs((new Date())
                .getFullYear() - 11 + ''))
          );
        }
      },
      endPickerOptions: {
        disabledDate: (time) => {
          return (
          // 限制不能选择结束年份之后：大于开始年份
            time.getTime() < Date.now() - this.dayjs((new Date()).getFullYear() + '').diff(this.dayjs(this.customizeForm
              .curStartYear)) ||
              // 限制不能选择未来和12年前：大于12年前小于上一年
              time.getTime() > Date.now() ||
              time.getTime() < Date.now() - this.dayjs((new Date()).getFullYear() + '').diff(this.dayjs((new Date())
                .getFullYear() - 11 + ''))
          );
        }
      },
      pickerMonthOptions: {
        onPick: ({
          maxDate,
          minDate
        }) => {
          // 把选择的第一个日期赋值给一个变量。
          this.choiceDate = minDate.getTime();
          // 如何你选择了两个日期了，就把那个变量置空
          if (maxDate) this.choiceDate = '';
        },
        disabledDate: (time) => {
          return time.getTime() > Date.now();
          // 如何选择了一个日期
          // if (this.choiceDate) {
          // const date = new Date();
          // const year = date.getFullYear();
          // let month = date.getMonth() + 1;
          // if (month >= 1 && month <= 9) {
          //   month = '0' + month;
          // }
          // const currentDate = year.toString() + month.toString();
          // const timeYear = time.getFullYear();
          // let timeMonth = time.getMonth() + 1;
          // if (timeMonth >= 1 && timeMonth <= 9) {
          //   timeMonth = '0' + timeMonth;
          // }
          // const timeDate = timeYear.toString() + timeMonth.toString();
          // return currentDate <= timeDate;
          // } else {
          // 如果没有选择日期，就要限制不能选择当月及以后
          // const t0 = time.getTime() < Date.now() - this.dayjs(this.dayjs(new Date()).subtract(1, 'months').format(
          //   'YYYY-MM'), 'YYYY-MM').daysInMonth() * 24 * 3600 * 1000 * 12;
          // const t1 = time.getTime() > Date.now() - this.dayjs(this.dayjs(new Date()).subtract(1, 'months').format(
          //   'YYYY-MM'), 'YYYY-MM').daysInMonth() * 24 * 3600 * 1000;
          // if (this.hasSingleDate) {
          //   return t1 || t0;
          // } else {
          //   return t1;
          // }
          // }
        }
      },
      pickerDayOptions: {
        onPick: ({
          maxDate,
          minDate
        }) => {
          // 把选择的第一个日期赋值给一个变量。
          this.choiceDate = minDate.getTime();
          // 如何你选择了两个日期了，就把那个变量置空
          if (maxDate) this.choiceDate = '';
        },
        disabledDate: (time) => {
          // 如何选择了一个日期
          if (this.choiceDate) {
            // 32天的时间戳
            const one = this.daysSpanValue * 24 * 3600 * 1000;
            // 当前日期 - one = 32天之前
            const minTime = this.choiceDate - one;
            // 当前日期 + one = 32天之后
            const maxTime = this.choiceDate + one;
            return (
              time.getTime() < minTime ||
                time.getTime() > maxTime ||
                // 限制不能选择今天及以后
                time.getTime() > Date.now() - 24 * 60 * 60 * 1000
            );
          } else {
            // 如果没有选择日期，就要限制不能选择今天及以后
            if (this.hasSingleDate) {
              return time.getTime() > Date.now() - 24 * 60 * 60 * 1000 || time.getTime() < Date.now() - 24 * 32 *
                  60 * 60 * 1000;
            } else {
              return time.getTime() > Date.now() - 24 * 60 * 60 * 1000;
            }
          }
        }
      },
      fastDateOptions: [{
        label: this.$t('今日'),
        beginDate: this.dayjs().format('YYYY-MM-DD'),
        endDate: this.dayjs().format('YYYY-MM-DD')
      },
      {
        label: this.$t('昨日'),
        beginDate: this.dayjs().subtract(1, 'days').format('YYYY-MM-DD'),
        endDate: this.dayjs().subtract(1, 'days').format('YYYY-MM-DD')
      },
      {
        label: this.$t('近7天'),
        beginDate: this.dayjs().subtract(7, 'days').format('YYYY-MM-DD'),
        endDate: this.dayjs().format('YYYY-MM-DD')
      },
      {
        label: this.$t('近30天'),
        beginDate: this.dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        endDate: this.dayjs().format('YYYY-MM-DD')
      },
      {
        label: this.$t('今年'),
        beginDate: this.dayjs().subtract(1, 'year').format('YYYY-MM-DD'),
        endDate: this.dayjs().format('YYYY-MM-DD')
      }
      ],
      customizeObj: {
        beginDate: '',
        endDate: '',
        show: false
      },
      dateLimit: this.dayjs().subtract(1, 'months').format('YYYY-MM-DD') + ' ~ ' + this.dayjs().subtract(1, 'days').format(
        'YYYY-MM-DD'),
      btnLoading: false,
      curFastDate: this.$t('近7天'),
      selDateLimit: this.dayjs().subtract(7, 'days').format('YYYY-MM-DD') + ' ~ ' + this.dayjs().format('YYYY-MM-DD'),
      hasConfirmDate: false
    };
  },
  watch: {
    initDateLimit(val) {
      const diff = this.dayjs(val[1]).diff(val[0], 'day');
      this.selDateLimit = val[0] + ' ~ ' + val[1];
      if (diff === 0) {
        if (this.dayjs().diff(val[0], 'day') > 0) {
          this.curFastDate = this.$t('昨日');
        } else {
          this.curFastDate = this.$t('今日');
        }
      } else if (diff === 7) {
        this.curFastDate = this.$t('近7天');
      } else if (diff > 7 && diff < 35) {
        this.curFastDate = this.$t('近30天');
      } else if (diff === 365) {
        this.curFastDate = this.$t('今年');
      } else {
        this.curFastDate = '';
      }
    }
  },
  mounted() {
    // this.curFastDate = this.fastDate;
  },
  methods: {
    handleDrawerDate() {
      if (this.customizeObj.beginDate === '') {
        this.customizeObj.beginDate = this.dayjs().subtract(1, 'months').format('YYYY-MM-DD');
        this.customizeObj.endDate = this.dayjs().subtract(1, 'days').format('YYYY-MM-DD');
        this.customizeObj.show = true;
      }
      this.isShowDrawerDialog = true;
    },
    handleConfirmDialog() {
      this.isShowDrawerDialog = false;
      this.hasConfirmDate = true;
      this.selDateLimit = this.dateLimit;
      this.curFastDate = this.dateLimit;
      this.customizeObj.show = true;
      this.$emit('showCustomize', this.customizeObj);
    },
    // 时间类型
    typeChange(val) {
      console.log('typeChange', val);
      switch (val) {
        case '0':
          this.rangeType = '0';
          this.customizeObj.beginDate = this.customizeForm.dayLimit[0];
          this.customizeObj.endDate = this.customizeForm.dayLimit[1];
          this.dateLimit = this.customizeForm.dayLimit[0] + ' ~ ' + this.customizeForm.dayLimit[1];
          break;
        case '1':
          this.rangeType = '1';
          this.customizeObj.beginDate = this.customizeForm.monthLimit[0] + '-01';
          this.customizeObj.endDate = this.customizeForm.monthLimit[1] + '-' + this.dayjs(this.customizeForm.monthLimit[1])
            .daysInMonth();
          this.dateLimit = this.customizeForm.monthLimit[0] + ' ~ ' + this.customizeForm.monthLimit[1];
          break;
        case '2':
          this.rangeType = '2';
          this.customizeObj.beginDate = this.customizeForm.curStartYear + '-01-01';
          this.customizeObj.endDate = this.customizeForm.curEndYear + '-12-' + this.dayjs(this.customizeForm.curEndYear +
              '-12').daysInMonth();
          this.dateLimit = this.customizeForm.curStartYear + ' ~ ' + this.customizeForm.curEndYear;
          break;
      }
    },
    // 时间-日期选择
    selDayLimit(val) {
      this.selDateLimit = val[0] + ' ~ ' + val[1];
      this.dateLimit = val[0] + ' ~ ' + val[1];
      this.customizeObj.beginDate = val[0];
      this.customizeObj.endDate = val[1];
    },
    selMonthLimit(val) {
      this.selDateLimit = val[0] + ' ~ ' + val[1];
      this.dateLimit = val[0] + ' ~ ' + val[1];
      this.customizeObj.beginDate = val[0] + '-01';
      this.customizeObj.endDate = val[1] + '-' + this.dayjs(val[1]).daysInMonth();
      this.$emit('handleMonthLimit', this.monthLimit);
    },
    // 年区间选择器
    handleChangeStart(val) {
      this.dateLimit = val + ' ~ ' + this.customizeForm.curEndYear;
      this.customizeForm.curStartYear = val;
      this.customizeObj.beginDate = val + '-01-01';
      if (this.customizeForm.curStartYear && this.customizeForm.curEndYear) {
        this.$emit('handleYearLimit', [this.customizeForm.curStartYear, this.customizeForm.curEndYear]);
      }
    },
    handleChangeEnd(val) {
      this.dateLimit = this.customizeForm.curStartYear + ' ~ ' + val;
      this.customizeForm.curEndYear = val;
      this.customizeObj.endDate = val + '-12-' + this.dayjs(val + '-12').daysInMonth();
      if (this.customizeForm.curStartYear && this.customizeForm.curEndYear) {
        this.$emit('handleYearLimit', [this.customizeForm.curStartYear, this.customizeForm.curEndYear]);
      }
    },
    // 统计维度
    fastChange(val) {
      this.selDateLimit = val.beginDate + ' ~ ' + val.endDate;
      this.curFastDate = val.label;
      this.fastDateOptions.forEach(item => {
        if (item.label === val.label) {
          this.customizeObj.beginDate = item.beginDate;
          this.customizeObj.endDate = item.endDate;
          this.customizeObj.show = false;
        }
      });
      this.hasConfirmDate = false;
      this.$emit('showCustomize', this.customizeObj);
    }
  }
};
</script>

<style lang="scss" scoped>
  ::v-deep .el-radio__input {
    display: none;
  }
  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
  ::v-deep .el-form-item__content {
    line-height: 30px;
  }
  ::v-deep .el-date-editor .el-range-separator {
    padding: 0;
  }
  .quick-date {
    float: right;
    .el-form-item__content {
      line-height: 30px !important;
    }
    .form-float-right {
      display: flex;
      float: right;
    }
    .customize-btn {
      color: $main;
      border: 1px solid $main;
      div {
        padding: 0 8px;
      }
      .dateLimit {
        color: $main;
      }
    }
    .quick-data-drawer {
      .el-drawer__header {
        font-family: PingFang SC;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        color: #303133;
      }
    }
  }
</style>
